<template>
  <div
    class="subheader py-2 py-lg-4"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex align-items-center flex-wrap mr-1">
        <h5 class="text-dark font-weight-bold my-2 mr-5">
          {{ title }}
        </h5>
        <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2"
        >
          <li class="breadcrumb-item">
            <router-link
              :to="{
                name: 'client.dashboard',
                params: { clinet_slug: clinet_slug }
              }"
              class="subheader-breadcrumbs-home"
            >
              <i class="flaticon2-shelter text-muted icon-1x"></i>
            </router-link>
          </li>

          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li class="breadcrumb-item" :key="`${i}-${breadcrumb.id}`">
              <router-link
                v-if="breadcrumb.route"
                :key="i"
                :to="{
                  name: breadcrumb.route,
                  params: { clinet_slug: clinet_slug }
                }"
                class="text-muted"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span class="text-muted" :key="i" v-if="!breadcrumb.route">
                {{ breadcrumb.title }}
              </span>
            </li>
          </template>
        </ul>
      </div>
      <!-- <div class="d-flex align-items-center">
        <a href="#" class="btn btn-light font-weight-bold btn-sm">
          Actions
        </a>

        
      </div> -->
    </div>
  </div>
</template>

<style lang="scss">
#kt_subheader {
  background: #f5f7fa !important;
  border-bottom: 1px solid #e8edf5;
  padding: 8px 0 !important;

  h5 {
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #0d1b3e !important;
    margin: 0 !important;
  }

  .breadcrumb {
    background: transparent;
    padding: 0;
    margin: 0;
    font-size: 12px;

    .breadcrumb-item {
      display: flex;
      align-items: center;

      a {
        color: #7a8499;
        text-decoration: none;
        transition: color 0.2s;
        &:hover { color: #1565c0; }
      }

      span { color: #7a8499; }

      i { color: #a0aab8; font-size: 13px; }

      &::before { color: #c5cfe0 !important; }
    }
  }
}

@media (min-width: 992px) {
  .header-fixed.subheader-fixed .subheader {
    top: 46px !important;
  }
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  data() {
    return {
      clinet_slug: ""
    };
  },
  created() {
    this.clinet_slug = this.$route.params.clinet_slug;
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>
